import { render } from "./CustomerFeedbackCRUD.vue?vue&type=template&id=49cc6edc&scoped=true"
import script from "../js/customer-feedback-crud.js?vue&type=script&lang=js"
export * from "../js/customer-feedback-crud.js?vue&type=script&lang=js"

import "./CustomerFeedbackCRUD.vue?vue&type=style&index=0&id=49cc6edc&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cc6edc"]])

export default __exports__